import { Flex } from '@chakra-ui/react'
import React from 'react'
import { TRANSCRIPT_SUMMARY_NOT_AVAILABLE } from '~/pages/Calls/CallDetails/CallDetailsAnalyticsContent'
import { CallTranscriptSummarySection } from '~/pages/Calls/CallDetails/sections/CallTranscriptSummarySection'
import { useGetCallTranscript } from '~/queries/callAnalyticsQueries'

export type CallSentimentTooltipProps = {
  pbxId: number
  callId: number
  callerSentiment: number
  officeSentiment: number
  isSummaryTooltip?: boolean
  isVoicemailTooltip?: boolean
}

export const CallSentimentTooltip = ({
  pbxId,
  callId,
}: CallSentimentTooltipProps) => {
  const transcriptsQuery = useGetCallTranscript(pbxId, callId)

  const summaryText =
    transcriptsQuery.data?.ConversationCharacteristics.ContactSummary
      ?.AutoGenerated.OverallSummary.Content

  const overallCustomerScore =
    transcriptsQuery.data?.ConversationCharacteristics.Sentiment
      .OverallSentiment.CUSTOMER ?? 0
  const overallAgentScore =
    transcriptsQuery.data?.ConversationCharacteristics.Sentiment
      .OverallSentiment.AGENT ?? 0

  return (
    <Flex width="25rem">
      <CallTranscriptSummarySection
        isLoading={transcriptsQuery.isLoading}
        summaryText={summaryText ?? TRANSCRIPT_SUMMARY_NOT_AVAILABLE}
        overallAgentScore={overallAgentScore}
        overallCustomerScore={overallCustomerScore}
      />
    </Flex>
  )
}
